import { Tables } from "../supabase.types";
import { genAbsoluteURL } from "@punchup/utils/genAbsoluteURL";

export type VideoRanks = Tables<"video_ranking_score">;

export const getCachedVideoRanks = async (): Promise<VideoRanks[]> => {
  // Note: because we are fetching a static path at build time, we cannot query a path while it's being built (same host) so we need to use an
  // existing deployment, hence the punchup.live URL. In dev on the other hand you can use localhost:3000 is built or cached.
  const response = await fetch(genAbsoluteURL("/api/getVideoRanks"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    throw new Error(`Error getting cached video ranks: ${response.statusText}`);
  }
  const data = await response.json();
  return data.videoRanks || [];
};
